import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppShell } from '@opcentral/framr-ui';
import '@opcentral/skinnr-lib/theme/opcentral.css';
import App from './App';
import './amplifyr.css';

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[Amplifyr] Unhandled error:', error, info.componentStack);
  }
  override render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, fontFamily: 'monospace', color: '#f87171' }}>
          <h2>Something went wrong</h2>
          <pre style={{ fontSize: 12, opacity: 0.7 }}>{this.state.error.message}</pre>
          <button
            onClick={() => this.setState({ error: null })}
            style={{ marginTop: 16, padding: '8px 16px', cursor: 'pointer' }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppShell namespace="amplifyr" appName="Amplifyr" theme="dark" layout="clean">
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </AppShell>
  </React.StrictMode>,
);
